import { type NavItemType } from '@/defs/nav'
import { cn } from '@/utils/commonUtil'

import styles from '../MenuNavMain.module.scss'
import { MenuNavMainButton } from '../MenuNavMainButton/MenuNavMainButton'

type Props = {
  item: NavItemType
}

export const MenuNavMainInner = ({ item }: Props) =>
  item.submenu && (
    <ul
      className={cn(styles.menuInner, {
        hasNoLabel: item.label === undefined,
        size: item.size,
        styles,
      })}
    >
      {item.submenu.map((itemInner) => (
        <li className={styles.itemInner} key={itemInner.id}>
          <MenuNavMainButton className={styles.buttonInner} item={itemInner} />
          {itemInner.submenu && <MenuNavMainInner item={itemInner} />}
        </li>
      ))}
    </ul>
  )
